module.exports = __webpack_public_path__ + "img/maleta.739d9623.png";